<template>
  <main>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-7" id="login-img"></div>
        <div class="col-md-3 offset-md-1 text-center">
          <form style="margin-top:15vh" @submit.prevent="login()">
            <img width="20%" class="mt-5" src="/img/logo.jpg" alt="AtChecher" />
            <h1 class="mt-2 text-primary">AtChecker</h1>

            <br />
            <b>Código de Usuario:</b>
            <input type="text" v-model="user" class="form-control" />
            <br />
            <b>Contraseña:</b>
            <input type="password" v-model="password" class="form-control" />
            <br />
            <button style="background-color:#333" class="btn btn-block text-light">Iniciar Sesión</button>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      url: this.$store.state.url,
      user: "",
      password: ""
    };
  },
  mounted() {
    localStorage.clear();
  },
  methods: {
    async login() {
      let data = {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password: this.password, user: this.user })
      };
      try {
        let req = await fetch(this.url + "schoolLogin", data);
        if (req.ok) {
          let result = await req.json();
          this.$store.commit("login", result);
          localStorage.setItem("jwt", "4fd024e5-b69c-4274-9b3a-a2828106dc71");

          this.$router.push("/");
        } else {
          this.$alert(
            "No se pudo iniciar sesión con las credenciales proporcionadas.",
            "Datos Incorrectos",
            "error"
          );
        }
      } catch (error) {
        this.$alert(error, "Ocurrió un Error", "error");
      }
    }
  }
};
</script>

<style scoped>
#login-img {
  background-image: url("/img/login.jpg");

  background-size: cover;
  background-position-x: center;
  background-position-y: center;
  background-repeat: no-repeat;
  height: 100vh;
}

main {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: #fff;
}
</style>